import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import WSTextField, { TextType } from '../../../Components/TextBox/WSTextBox';
import WSPhone from '../../../Components/Phone/WSPhone';

export const Step8Emergency = () => {
  const { control } = useFormContext();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Emergency Contact Name" fullWidth {...register('emergencyContact.name')} error={!!errors?.emergencyContact}
          helperText={errors?.emergencyContact?.message as string}/> */}
           <WSTextField id="emergencyContact.name" label={"Emergency Contact Name"} control={control} name='emergencyContact.name' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Emergency Contact Number" fullWidth {...register('emergencyContact.number')} error={!!errors?.emergencyContact}
          helperText={errors?.emergencyContact?.message as string}/> */}
           {/* <WSTextField id="emergencyContact.number" label={"Emergency Contact Number"} type={TextType.pho} control={control} name='emergencyContact.number' /> */}
           <WSPhone id="emergencyContact.number" label={"Emergency Contact Number"} control={control} name='emergencyContact.number'/>
      </Grid>
      <Grid item xs={12}>
        {/* <TextField label="Relationship" fullWidth {...register('emergencyContact.relationship')} error={!!errors?.emergencyContact}
          helperText={errors?.emergencyContact?.message as string}/> */}
           <WSTextField id="emergencyContact.relationship" label={"Relationship"} control={control} name='emergencyContact.relationship' />
      </Grid>

      <Grid item xs={12} sm={6}>
                <WSTextField id="password" label={"Password"} control={control} name='password'/>
            </Grid>

            <Grid item xs={12} sm={6}>
                      <WSTextField id="confirmPassword" label={"Confirm Password"} control={control} name='confirmPassword'/>
                  </Grid>
    </Grid>
  );
};